import React from 'react';
import { useSelector } from 'react-redux';
import { GlobalStore } from '../../store';
import User from '../../models/User';

interface Props {
  queueName: string;
  queueLocked: boolean;
  checkinState: 1 | 2 | 3;
  onCheckin: () => void;
  onCancel: () => void;
  onCheckout: () => void;
}

export default ({ queueName, queueLocked, checkinState, onCheckin, onCancel, onCheckout }: Props): JSX.Element | null => {
  const user = useSelector<GlobalStore, User | null>(store => store.user);

  if (!user) return null;
  if (!user.isTeacherIn(queueName) && !user.isAssistantIn(queueName)) return null;

  if (checkinState === 1) {
    // You can't report for duty on a locked queue, so hide the check-in button.
    // Check-out (states 2 and 3) stays available while locked: a session often
    // locks before it ends, and TAs who leave must still be able to check out so
    // the on-duty list reflects who actually stays overtime.
    if (queueLocked) return null;
    return (
      <div
        className="text-white px-3 py-2 theme clickable text-center mt-3 mb-3"
        style={{ borderRadius: '4px' }}
        onClick={onCheckin}
      >
        Check in for duty
      </div>
    );
  }

  if (checkinState === 3) {
    return (
      <div
        className="text-white px-3 py-2 clickable text-center mt-3 mb-3"
        style={{ borderRadius: '4px', backgroundColor: '#dc3545' }}
        onClick={onCheckout}
      >
        Check out from queue
      </div>
    );
  }

  return (
    <>
      <div
        className="text-white px-3 py-2 yellow clickable text-center mt-3 mb-1"
        style={{ borderRadius: '4px' }}
        onClick={onCancel}
      >
        Cancel check-in
      </div>
      <div
        className="text-white px-3 py-2 clickable text-center mb-3"
        style={{ borderRadius: '4px', backgroundColor: '#dc3545' }}
        onClick={onCheckout}
      >
        Check out from queue
      </div>
    </>
  );
};
